import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { I18nBreadcrumb } from '@/components/ui/i18breadcrumb';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/documents'
)({
  validateSearch: zodValidator(
    z.object({
      order: fallback(z.enum(['asc', 'desc']), 'asc'),
    })
  ),
  staticData: { breadcrumb: () => <I18nBreadcrumb translationKey="documents" /> },
});
